import React from 'react'
import { Box, Typography, Link } from '@mui/material'

interface Country {
    name: string
    href: string
}

interface TopCountriesProps {
    title: string
    countries: Country[]
}

export const TopCountries: React.FC<TopCountriesProps> = ({ title, countries }) => {
    return (
        <Box sx={{ px: 3, py: 2 }}>
            <Typography
                variant="subtitle1"
                sx={{
                    fontWeight: 700,
                    mb: 2,
                    fontSize: '14px',
                    color: 'text.primary'
                }}
            >
                {title}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5
                }}
            >
                {countries.map((country, index) => (
                    <Link
                        key={index}
                        href={country.href}
                        target="_parent"
                        sx={{
                            color: 'text.secondary',
                            textDecoration: 'none',
                            fontSize: '12px',
                            '&:hover': {
                                color: 'primary.main',
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {country.name}
                    </Link>
                ))}
            </Box>
        </Box>
    )
}

export type { TopCountriesProps }
